import styled from "styled-components";
import { TituloH1 as TituloPrincipal } from "../../../../components/TituloSorriso/styles";
import { media } from "src/layouts/utils";

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
  padding: 40px 0 36px;
  background-color: #742b82;

  ${media.desktop`
    height: fit-content;
    padding: 24px 0;
  `}
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  justify-content: center;

  ${media.desktop`
    width: 100%;
    display: block;
    text-align: center;
    padding: 5px;
    margin: 0;
  `}
`;

export const TextWrap = styled.div`
  padding: 20px 20px 0;

  @media only screen and (max-width: 962px) and (min-width: 768px) {
    max-width: 70%;
    margin: 0 auto;
  }
`;

export const Title = styled(TituloPrincipal)`
  color: #fff;
  padding: 0;
  text-align: center;
  font-weight: 700;
  margin-bottom: 10px;
  line-height: 45px;
  padding-bottom: 20px;

  ${media.desktop`
    max-width: 100%;
    line-height: 32px;
  `}
`;

export const Text = styled.div`
  width: 95%;
  margin-left: auto;
  margin-right: auto;
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  text-align: center;
  color: #ffffff;
  padding-bottom: 16px;

  ${media.phone`
    margin-left: auto;
    margin-right: auto;
    font-size: 20px;
    line-height: 28px;
  `}
`;

export const Subtext = styled.div`
  width: 100%;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  letter-spacing: 0;
  line-height: 24px;
  color: #ffffff;
  padding-bottom: 12px;

  ${media.phone`
    margin-left: auto;
    margin-right: auto;
  `}
`;

export const SmallText = styled(Subtext)`
  font-size: 14px;
  padding: 0;
  ${media.phone`
    padding-bottom: 12px;
  `}
`;
